export enum DialerSeat {
  NONE = "NONE",
  SINGLE_LINE = "SINGLE_LINE",
  MULTI_LINE = "MULTI_LINE",
}
